import React, { useState, useCallback, useEffect, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../store/actions/index'
import styles from './CrmModal.module.css'
import { Modal, Button, Form, Tabs, Tab, Row, Col } from 'react-bootstrap';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ModuleBuilder from './ModuleBuilder/ModuleBuilder';
// import ModuleRecords from './ModuleRecords/ModuleRecords';
import ModuleData from './ModuleRecords/ModuleData';
import { IoCloseOutline, IoArrowForward } from "react-icons/io5";
import { addOrUpdateNavPath } from '../../../store/actions';
import CreateModule from './ModuleBuilder/CreateModule';

const CrmModal = ({onSelectConv,OnAddToDialListClicked}) => {
    const [t] = useTranslation('crm')
    const navigate = useNavigate();
    const crmState = useSelector(state => state.crm)
    const alertCtx = useContext(AlertContext)
    const [showCreateModule, setShowCreateModule] = useState(false)
    const dispatch = useDispatch()

    const { errorMsg, successMsg, selectedCrmModule, crmPath, navigationPath, loading } = crmState
    const { name: moduleName, value: recordId } = crmPath

    useEffect(() => {
        if (loading) {
            // Show loading spinner in alert modal
            alertCtx.showAlert('', <div style={{textAlign: 'center', padding: '20px'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'md')
        }
    }, [loading])

    useEffect(() => {
        if (errorMsg) {
            alertCtx.showAlert(t('Error'), t(errorMsg), 'md', () => dispatch(actions.onCloseCrmAlertModalHandler()))
        }
    }, [errorMsg])

    useEffect(() => {
        if (successMsg) {
            alertCtx.showAlert(t('Action succeeded'), t(successMsg), 'md', () => dispatch(actions.onCloseCrmAlertModalHandler()))
        }
    }, [successMsg])

    const onHide = () => {
        dispatch(actions.setCrmModule())
        dispatch(actions.initCrmModule())// refresh all modules
        navigate(`/`)
    }

    const onBackOrExit = () => {
        if (navigationPath && navigationPath.length > 1) {
            // Find the previous meaningful path (skip grids, go back to last record or grid)
            // Start from second-to-last and work backwards
            let targetIndex = navigationPath.length - 2;

            // If we're currently in a record, go back to the previous record or parent record
            const currentPath = navigationPath[navigationPath.length - 1];
            if (currentPath.recordId !== null) {
                // We're in a record, find the previous record (skip grids)
                for (let i = navigationPath.length - 2; i >= 0; i--) {
                    if (navigationPath[i].recordId !== null) {
                        // Found a previous record, use it
                        targetIndex = i;
                        break;
                    } else if (i === 0) {
                        // No previous record, go to the first grid
                        targetIndex = 0;
                        break;
                    }
                }
            }

            const previousPath = navigationPath[targetIndex];
            navigate(previousPath.href);
        } else {
            // No navigation path or only one item, close the modal
            onHide();
        }
    }

    const hasBackNavigation = navigationPath && navigationPath.length > 1;

    useEffect(() => {
        if (selectedCrmModule?.name !== moduleName) {
            dispatch(actions.refreshCrmModule(moduleName))
        }
    }, [selectedCrmModule?.name, moduleName])

    useEffect(() => {
        if (!selectedCrmModule ||
            selectedCrmModule.name.toLowerCase() !== moduleName.toLowerCase() ) return;

        dispatch(addOrUpdateNavPath({
            module: moduleName,                  // "contacts"
            recordId: null,                        // list page
            label: selectedCrmModule.label,     // "Contacts"
            href: `/crm/${moduleName}/records/`
        }));
    }, [moduleName, recordId, selectedCrmModule?.name]);



    let modalTitle = selectedCrmModule?.label || '' //|| t(crmState.crmPath.name)
    let showBody = null

    if ((crmState.crmPath.name !== 'modules' || crmState.crmPath.attribute !== 'create') && showCreateModule) setShowCreateModule(false)

    if (crmState.crmPath.attribute === 'settings') {
        modalTitle = selectedCrmModule?.label && t('Module managment', { module: selectedCrmModule?.label })
        showBody = <ModuleBuilder crmState={crmState} />
    }
    else if (crmState.crmPath.attribute === 'records' || (crmState.crmPath.attribute === 'create' && crmState.crmPath.name!=='modules')) {
        showBody = <ModuleData crmState={crmState} onSelectConv={onSelectConv} OnAddToDialListClicked={OnAddToDialListClicked} newRecord={crmState.crmPath.attribute==='create' && crmState.crmPath.name!=='modules'}/>
    }
    else if (crmState.crmPath.name === 'modules' && crmState.crmPath.attribute === 'create') {
        modalTitle = t('New module')
        showBody = undefined
        if (!showCreateModule)
            setShowCreateModule(true)
    }

    const goToModuleSettings = useCallback((module) => {
        if (!module?.name) return navigate(`/`)
        const toModuleName = module.name
        dispatch(actions.setCrmModule(module, 'select'))
        navigate(`/crm/${toModuleName}/settings/fields-managment`)
    }, [])

   

    return (
        <>
            <Modal show={!showCreateModule && modalTitle} onHide={onHide} dialogClassName={styles[`crm-modal`]} size="xl" centered aria-labelledby="contained-modal-title-vcenter" className={`rtl-modal`} >
                <Modal.Header className={`${styles['modal-header']}`}>
                    <Modal.Title className={`${styles['modal-title']}`}>{modalTitle}</Modal.Title>
                    {hasBackNavigation ? (
                        <IoArrowForward className={styles['nav-icon']} onClick={onBackOrExit} />
                    ) : (
                        <IoCloseOutline className={styles['nav-icon']} onClick={onBackOrExit} />
                    )}
                </Modal.Header>
                <Modal.Body id='file-manager-model' className={styles[`modal-body`]} >
                    {showBody}
                </Modal.Body>
                {/* <Modal.Footer className={`${styles['modal-footer']}`}>
                <div className={`${styles['modal-footer-side']}`}>
                    <Button variant="secondary" onClick={onHide}>{t('Exit')}</Button>
                </div>
            </Modal.Footer> */}
            </Modal>

            <CreateModule
                show={showCreateModule}
                onHide={goToModuleSettings}
            />
        </>
    )
}

export default React.memo(CrmModal)